// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack-edge/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#section-contact .content h3{font-size:1.4em;font-weight:600;padding:0 0 .5em;color:#990516}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
